import { MatCalendar } from '@angular/material/datepicker';

/**
 * Angular Material 19.2.x Datepicker Calendar Fix
 * 
 * Problem: Angular Material 19.2.x can skip running MatCalendar.ngAfterContentInit 
 * when tree-shaken through the esbuild/Vite pipeline. This leaves `currentView` 
 * undefined, causing the internal template to never render any view cases.
 * 
 * Solution: Patch the currentView getter to fall back to startView (defaults to 'month')
 * when the original value is undefined.
 * 
 * This file must be imported in main.ts BEFORE bootstrapApplication.
 */
const currentViewDescriptor = Object.getOwnPropertyDescriptor(MatCalendar.prototype, 'currentView');

if (currentViewDescriptor?.get) {
    const originalGetter = currentViewDescriptor.get;
    const originalSetter = currentViewDescriptor.set;

    Object.defineProperty(MatCalendar.prototype, 'currentView', {
        get: function patchedCurrentView(): string {
            const value = originalGetter.call(this);
            return value ?? this.startView ?? 'month';
        },
        set: function patchedSetCurrentView(view: string): void {
            const sanitizedView = view ?? this.startView ?? 'month';
            if (originalSetter) {
                originalSetter.call(this, sanitizedView);
            }
        },
        enumerable: currentViewDescriptor.enumerable,
        configurable: currentViewDescriptor.configurable,
    });
}
